export default __webpack_public_path__ + "static/media/logOut.baf72b31.svg";